import styled from 'styled-components';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { View } from '../Basic/View/view';
import { Row } from '../Basic/Row/row';
import { Col } from '../Basic/Col/col';

export const CheckboxPrimitiveRoot = styled(CheckboxPrimitive.Root)`
  all: unset;
  background-color: ${props => props.theme.colors.card};
  width: 15px;
  height: 15px;
  border-radius: 6px;
  border: 1.5px solid;
  border-color: ${props => props.theme.colors.primary};
  
  display: flex;
  align-items: center;
  justify-content: center;

  -webkit-box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

`;
export const CheckboxIndicator = styled(CheckboxPrimitive.Indicator)`
  
`;

export const Checkbox = styled.input`
  background-color: ${props => props.theme.colors.card};
  width: 15px;
  height: 15px;
  border-radius: 10px;
  border: 1.5px solid;
  border-color: red;

  display: flex;
  align-items: center;
  justify-content: center;

  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);


`;

export const CheckboxArea = styled(Row)`

    display: flex;
    align-items: center;
    flex-direction: row;
`;

export const CheckboxInput = styled(View)`
  margin-right:10px;
  cursor: pointer;

`;

export const CheckboxChild = styled(Col)`
  display: flex;
    align-items: center;
    flex-direction: row;
`;







